module.exports = __webpack_public_path__ + "1.5.0-unryo/img/offline-vault-4.ccb41fd3.svg";